import React from "react";
import { SkeletonText } from "../../../components/UI/DesignStandards";

const LoadingSkeleton = () => (
  <div className="min-h-screen bg-brand-cream">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
      <div className="card-board overflow-hidden">
        <div className="bg-brand-charcoal px-6 py-4">
          <SkeletonText size="lg" width="40" className="bg-brand-mist/30" />
          <SkeletonText size="sm" width="56" className="bg-brand-mist/20 mt-2" />
        </div>
        <div className="px-4 py-3 flex gap-4">
          <SkeletonText size="sm" width="16" />
          <SkeletonText size="sm" width="20" />
          <SkeletonText size="sm" width="16" />
        </div>
      </div>
      <div className="card-board overflow-hidden">
        <div className="p-6 space-y-4">
          <SkeletonText size="lg" width="1/3" />
          <SkeletonText size="sm" width="2/3" />
          <SkeletonText size="sm" width="1/2" />
        </div>
      </div>
    </div>
  </div>
);

export default LoadingSkeleton;
